<mat-card>
  <div>Please enter all the relevent numbers for this equation</div>
  <mat-card-content>
    <mat-grid-list cols="8" [rowHeight]="35">
      <mat-grid-tile> Start Depth New </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepthNew" type="number"    placeholder="0" required ngDefaultControl >
      </mat-grid-tile>
      <mat-grid-tile> Start Depth 10% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_10" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 20%</mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_20" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 30% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_30" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <mat-grid-list cols="8" [rowHeight]="35">
      <mat-grid-tile> Start Depth 40% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_40" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 50% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_50" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 60% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_60" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 70% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_70" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>

    </mat-grid-list>
  </mat-card-content>

</mat-card>
<mat-card>
  <mat-card-content>
    <mat-grid-list cols="8" [rowHeight]="35">
      <mat-grid-tile> Start Depth 80% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_80" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 90% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_90" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 100% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_100" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>
      <mat-grid-tile> Start Depth 110% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_110" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>

    </mat-grid-list>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <mat-grid-list cols="8" [rowHeight]="35">
        <mat-grid-tile> Start Depth 120% </mat-grid-tile>
      <mat-grid-tile>
        <input [(ngModel)]="steppedCalMethod.StartDepth_120" type="number"    placeholder="0" required ngDefaultControl > </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card>